import qs from 'qs';
import axios from 'axios';
import Cookie from 'js-cookie';
import {cloneDeep, throttle} from 'lodash';
import {AppStore} from 'config/Stores';
import siteConfig from 'config/Config';
import { clearAllCookie } from 'utils/store';
import { Message } from 'antd';

axios.defaults.timeout = 60000;
//axios.defaults.baseURL = '';
axios.defaults.withCredentials = true;


/**
 * token过期或者未登录
 * */
const redirectToLogin = () => {
  Message.error('登录失效，请重新登录')
  clearAllCookie()
  window.app.router.push('/login')
  alertIng = true
  setTimeout(()=> {
    alertIng = false
  },1000)
};

let alertIng = false
/**
 * 如果登录了，就把token写入header
 * */
// 请求拦截
axios.interceptors.request.use(
  config => {
    // url配置
    config.url = siteConfig.apiAppName(config);
    // 设置响应类型为json
    config.responseType = 'json';
    // 取出headers
    let headers = cloneDeep(config.headers);

    const isLoginded = window.localStorage.getItem('isLogined');
    let auth = Cookie.get(siteConfig.cookie.auth_name) || window.localStorage.getItem('token');
    if (config.method != 'post' && config.method != 'POST' && config.method != 'PUT' && config.method != 'put') {
      config.params = config.data;
    }

    // 不传入，则默认为空对象
    headers = headers ? headers : {}
    // 解决ie不重新请求问题
    headers = {
      ...headers,
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': -1
    }

    if (!auth) {
      headers.auth = auth;
    }

    // Content-type默认为表单提交

    if (!headers['X-Real-Hostname']) {
      headers['X-Real-Hostname'] = siteConfig.ENV === 'loc' ? siteConfig.hostName : `${window.document.location.origin}${window.document.location.pathname}`
     }
    if (!headers['Content-type']) {
      headers['Content-type'] = 'application/json;charset=utf-8';
    }
    if (!headers["Access-Token"]) {
      headers["Access-Token"] = Cookie.get('boc_auth');
    }

    if (process.env.NODE_ENV !== 'production') {
      if (!headers["Application-Key"]) {
          headers["Application-Key"] = Cookie.get(siteConfig.cookie.appKey) || siteConfig.appKey;
          // headers["Application-Key"] = "6ad56a704a744a5980f7d8597be59376"
      }
    }
    
    config.withCredentials = false;
    config.headers = headers;
    // console.log('request config: ', config, 'request data: ', config.data);
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

//响应拦截
axios.interceptors.response.use(
  response => {
    // 非路由初始化，才立即隐藏loading
    if (!response.config.headers.router_init) {
      AppStore.hideLoading();
    }
    if (response.data && response.data.resultCode != 0) {
      Message.error(response.data && response.data.resultMsg);
    }
    return response.data;
  },
  error => {
    console.error(93, error.response)
    if (error.response) {
      switch (error.response.status) {
        case 401:
          if(!alertIng){
            redirectToLogin()
          }
          break
        default: 
          Message.error(error.response.data.resultMsg || error.response.data.message || error.response.statusText || '请求失败！');
      }
    }
    else{
      Message.error('请求失败');
    }
    return {
      resultMsg: error.response.data.resultMsg || error.response.data.message || error.response.statusText || '请求失败！'
    }
  }
);

export default axios;



// WEBPACK FOOTER //
// ./src/utils/request.js